import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { useLang, api } from "../store";
import { PageHead, Reveal } from "../components/Reveal";
import FilmModal from "../components/FilmModal";
import Footer from "../components/Footer";
import Marquee from "../components/Marquee";

const HERO_IMGS = [
  "/stunt/s4.jpg",
  "/stunt/s3.jpg",
  "/stunt/s1.jpg",
  "/stunt/s5.jpg",
  "/stunt/s2.jpg",
];


export default function Stunt() {
  const { t } = useLang();
  const [stuntFilms, setStuntFilms] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/films?role=stunt").then((r) => setStuntFilms(r.data)).catch(() => setStuntFilms([]));
  }, []);

  return (
    <div className="min-h-screen" data-testid="stunt-page">
      <PageHead kicker="STUNT DEPT · DANGER ZONE" title={t("stunt.title")} sub={t("stunt.sub")} />

      <div className="mx-auto max-w-[1600px] px-6">
        <div className="columns-1 gap-4 sm:columns-2 lg:columns-3" data-testid="stunt-photos">
          {HERO_IMGS.map((img, i) => (
            <div key={img} className="mb-4 break-inside-avoid">
              <Reveal delay={(i % 3) * 0.08}>
                <div className="poster-frame overflow-hidden rounded border border-white/10">
                  <img src={img} alt="" loading="lazy" className="w-full object-cover" data-testid={`stunt-photo-${i}`} />
                </div>
              </Reveal>
            </div>
          ))}
        </div>

        <Reveal className="mt-16">
          <div className="rounded border border-red-900/40 bg-[#120a0a] p-8">
            <p className="font-mono2 flex items-center gap-2 text-[11px] tracking-[0.3em] text-red-500"><Flame size={14} /> SPECIALIZZAZIONI / DISCIPLINES</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {t("stunt.skills").map((s) => (
                <span key={s} className="font-display rounded-full border border-red-800/60 px-4 py-2 text-sm uppercase tracking-wide text-red-300">{s}</span>
              ))}
            </div>
            <p className="font-mono2 mt-6 text-xs leading-relaxed tracking-wide text-slate-500">{t("stunt.certs")}</p>
          </div>
        </Reveal>

        <Reveal className="mt-16">
          <h2 className="font-display text-2xl uppercase tracking-tight sm:text-3xl">{t("stunt.credits")}</h2>
        </Reveal>
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {stuntFilms.map((f) => (
            <button key={f.id} onClick={() => setSelected(f)} data-testid={`stunt-film-${f.id}`} className="poster-frame group relative aspect-[2/3] overflow-hidden rounded border border-white/10 text-left">
              {f.poster ? (
                <img src={f.poster} alt={f.title} loading="lazy" className="h-full w-full object-cover" />
              ) : (
                <div className="flex h-full items-center justify-center bg-[#14181f] p-4"><span className="font-display text-center uppercase text-slate-500">{f.title}</span></div>
              )}
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-3 pt-8">
                <p className="font-display text-sm uppercase">{f.title}</p>
                <p className="font-serif-it text-sm italic text-red-400">{f.character}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Marquee />
      <FilmModal film={selected} onClose={() => setSelected(null)} />
      <Footer />
    </div>
  );
}
